/**
 * Wanderzirkus brand bits shared across the POS surfaces (Tally POS Design
 * System, project 4faf9d8e). The crew badge is the hero graphic — a stark
 * monochrome ransom-note roundel; it stays monochrome (cream on tar), the coral
 * lives around it. Served from /pos/ (web/public/pos/).
 */
export const POS_BADGE_SRC = "/pos/wanderzirkus-badge-cream.png";
export const POS_READER_SRC = "/pos/sumup-solo.png";

export const PosBadge = ({
  size = 28,
  className,
}: {
  size?: number;
  className?: string;
}) => (
  <img
    src={POS_BADGE_SRC}
    alt="Wanderzirkus"
    width={size}
    height={size}
    className={className}
    style={{ display: "block", objectFit: "contain" }}
  />
);
